import { defineMessages } from 'react-intl';

export default defineMessages({
  seemore: {
    id: 'view.appStatus.seeMore',
    defaultMessage: 'See more',
  },
  lastUpdate: {
    id: 'view.appStatus.lastUpdate',
    defaultMessage: 'Last update: {time}',
  },
});
